<template>
  <v-dialog v-model="modal" width="640px">
    <v-card>
      <v-card-title>{{ $t('messenger.actions.shareoffer.title.default') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step editable :step="1" :complete="step > 1">{{ $t('messenger.actions.shareoffer.title.kind') }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable :step="2" :complete="step > 2">{{ $t('messenger.actions.shareoffer.title.offer') }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable :step="3">{{ $t('messenger.actions.shareoffer.title.message') }}</v-stepper-step>
          </v-stepper-header>

          <v-stepper-content :step="1">
            <v-select
              v-model="scope"
              :label="$t('messenger.actions.shareoffer.labels.scope')"
              :items="scopes"
              item-text="name"
              item-value="code">
            </v-select>
          </v-stepper-content>

          <v-stepper-content :step="2">
            <v-list
              two-line
              subheader>
              <v-list-item
                v-for="offer in services"
                :key="offer.id">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ offer.title }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      <price :value="offer.price"></price>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn primary outline light @click.native.stop="select(offer)">{{ $t('messenger.actions.shareoffer.select') }}</v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list-item>
            </v-list>
          </v-stepper-content>

          <v-stepper-content :step="3">
            <offer-preview v-if="offer" :value="offer"></offer-preview>
            <v-text-field
              v-model="message"
              :label="$t('messenger.actions.shareoffer.labels.message')"
              autofocus
              multi-line>
            </v-text-field>
          </v-stepper-content>
        </v-stepper>

        <v-divider></v-divider>
      </v-card-text>
      <v-card-row actions>
        <!-- need a == and not === because the step is a string when you click to a previous step from the header -->
        <v-btn v-if="step === 1" primary light @click.native="step = 2">{{ $t('messenger.actions.shareoffer.next') }}</v-btn>
        <v-btn v-if="step === 2" primary light @click.native="step = 3">{{ $t('messenger.actions.shareoffer.next') }}</v-btn>
        <v-btn v-if="step === 3" :loading="loading" primary light @click.native.stop="submit()">{{ $t('messenger.actions.shareoffer.submit') }}</v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Service from '@/api/service'
  import chatMessage from '@/mixins/chatMessage'
  import autoOpenModal from '@/mixins/autoOpenModal'
  import { Price } from '@/components/formatters'
  import OfferPreview from '../previews/Offer.vue'
  export default {
    components: {
      Price,
      OfferPreview
    },
    mixins: [
      autoOpenModal,
      chatMessage
    ],
    data () {
      return {
        step: 1,
        scope: 'public',
        message: null,
        offer: null
      }
    },
    computed: {
      ...mapGetters({
        servicesLoading: 'skiliko/services/isLoading',
        servicesByScope: 'skiliko/services/servicesByScope'
      }),
      scopes () {
        return Service.AVAILABLE_SCOPES
          .map(e => ({ name: this.$t(`messenger.actions.shareoffer.scopes.${e}`), code: e }))
      },
      services () { return this.servicesByScope[this.scope] || [] }
    },
    watch: {
      scope () { this.fetchAll({ scope: this.scope }) }
    },
    methods: {
      ...mapActions({
        fetchAll: 'skiliko/services/fetchAll'
      }),
      select (offer) {
        this.offer = offer
        this.step = 3
      },
      submit () {
        this.send({
          content: this.message,
          data: { ...this.offer, type: 'offer' }
        })
          .then(_ => this.close())
      }
    },
    mounted () {
      this.fetchAll({ scope: this.scope })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/messenger/actions/ShareOffer.vue